import authAxios from "../utils/authAxios";

class FeatureFlagClient {
    async getFeatureFlags() {
        try {
            console.log("[FeatureFlagClient] Sending request to /api/feature-flags");
            const response = await authAxios("/api/feature-flags", {
                method: "GET",
            });
            console.log("[FeatureFlagClient] Full response object:", response);
            return response; // Возвращаем весь ответ без обращения к data
        } catch (error) {
            console.error("[FeatureFlagClient] Failed to fetch feature flags", error);
            throw error;
        }
    }
}

const featureFlagClient = new FeatureFlagClient();

export default featureFlagClient;
